const rootFontSize = () => parseFloat(getComputedStyle(document.body).fontSize);

export const remToPx = (rem) => rootFontSize() * rem;
